import { Component, OnInit } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import { ActivatedRoute } from '@angular/router';
import { SocietiesService } from '@app/shared/services/societies.service';
import { AlertService } from '@app/shared/services/alert.service';
import { SessionService } from '@app/shared/services/session.service';

import { societyPricesPreconfig } from '@app/shared/interfaces/society-prices-preconfig';

@Component({
    selector: 'app-society-informations',
    templateUrl: './society-informations.component.html',
    styleUrls: ['./society-informations.component.scss']
})
export class SocietyInformationsComponent implements OnInit {

    public id: string = '0';
    public society: any = {};
    public loading: boolean = true;
    public formChanged: boolean = true;
    public members: Array<any> = [];
    public noMemberResult: boolean = false;
    public loadingMember: boolean = true;

    public prixHoraire: string = '0';
    public prixJournalier: number = 0;
    public prixKilometre: string = '0';
    public remise: string = '';

    public prices: any = societyPricesPreconfig.config1;

    constructor(
        private titleService: TitleService,
        private menu: MenuService,
        private route: ActivatedRoute,
        private societyService: SocietiesService,
        private alertService: AlertService,
        public session: SessionService
    ) { }

    ngOnInit() {
        this.infoPrice();
        this.id = this.route.snapshot.paramMap.get('id');
        this.titleService.setTitle(`Information sur l'adhérent / VOP`);
        // Admin users reach this page via the dashboard "Infos" tab — keep the
        // dashboard menu context so the sub-tabs remain visible.
        // Super-admins navigate here from the society list and get the adherent context.
        if (this.session.role.ability === 'admin') {
            this.menu.setMenuState('dashboard', 'society', '');
        } else {
            this.menu.setMenuState('adherent', 'society', 'information');
        }
        this.menu.id = this.id;

        this.societyService.getSociety(parseInt(this.id, 10)).then((res) => {
            this.society = res;
            this.loading = false;
        });
        this.retrieveSocietyMembers();
    }

    infoPrice(): void {
        if (this.prices.priceType === "hours") {
            let date = new Date();
            let day = date.getDay();
            this.prixHoraire = this.prices.hourPrices[day];
            this.prixJournalier = this.prices.limitHourPerDay * this.prices.hourPrices[day];
            this.prixKilometre = this.prices.kmPrice;
            if (this.prices.discounts[0].condition === "kilometers") {
                this.remise = this.prices.discounts[0].amount + " " + this.prices.discounts[0].symbol + " de remise de " + this.prices.discounts[0].conditionAmount + " à " + this.prices.discounts[0].conditionAmountMax + " km";
            }
        }
        else if (this.prices.priceType === "blocks") {
            let date = new Date();
            let hour = date.getHours();

            for (let i = 0; i < this.prices.blocks.length; i++) {
                if (this.prices.blocks[i].start <= hour && this.prices.blocks[i].end >= hour) {
                    this.prixHoraire = this.prices.blocks[i].amount;
                    this.prixJournalier = this.prices.limitHourPerDay * this.prices.blocks[i].amount;
                    this.prixKilometre = this.prices.kmPrice;
                    if (this.prices.discounts[0].condition === "blocks") {
                        this.remise = this.prices.discounts[0].amount + " " + this.prices.discounts[0].symbol + " de remise de " + this.prices.discounts[0].conditionAmount + " à " + this.prices.discounts[0].conditionAmountMax + " km";
                    }
                }
            }
        }
    }

    updateSociety(): void {
        this.societyService.updateSociety(this.society).then(() => {
            this.alertService.alert("Les modifications ont été effectuées.");
        });
    }

    retrieveSocietyMembers(): void {
        this.noMemberResult = false;
        this.loadingMember = true;
        this.societyService.getStaffMembers(this.id).then((res) => {
            this.members = res;
            if (this.members.length === 0) {
                this.noMemberResult = true;
            }
            this.loadingMember = false;
        })
    }

    addSocietyMember(selectedMember): void {
        // selectedMember.AccountId = 220
        console.log(this.members.some(members => members.AccountId == selectedMember.AccountId))
        if (!this.members.some(members => members.AccountId == selectedMember.AccountId)) {
            this.members.push(selectedMember);
            this.updateSocietyMembers();
        }
        else {
            this.alertService.error('Ce membre est déjà adhérent');
        }
    }

    deleteSocietyMember(selectedMember): void {
        let index = this.members.findIndex((member) => member.AccountId === selectedMember.AccountId);

        if (index === -1) { return; }
        this.members.splice(index, 1);
        this.updateSocietyMembers();
    }

    updateSocietyMembers(): void {
        let idMemberList = [];

        this.members.forEach((member) => {
            idMemberList.push(member.AccountId);
        });
        this.societyService.updateStaffMembers(this.id, idMemberList);
    }
}
